export const environment = {
  production: false,
  /**
   * API origin (no trailing slash). Staging redeemee-node.
   * Leave empty (`''`) to use relative `/api/*` with a dev proxy instead.
   */
  apiOrigin: 'https://staging-api.redeemee.ai',
  /** Sent as `user_id` on `POST /api/redemptions` until auth supplies a real user. */
  redemptionUserId: 1,
  /** `POST /api/giftaway/order/process` sender fields (digital voucher flow). */
  giftawaySenderName: 'Redeemee User',
  giftawaySenderEmail: 'admin@inventlabs.tech',
  giftawayRecipientName: 'Redeemee',
};
